import { render, staticRenderFns } from "./RiverWaterRegime.vue?vue&type=template&id=053c86c7&scoped=true&"
import script from "./RiverWaterRegime.vue?vue&type=script&lang=js&"
export * from "./RiverWaterRegime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c86c7",
  null
  
)

export default component.exports